import { type FmhcReport as GqlFmhcReport } from '../../../../../../graphql/lo1/generated';
import { SubjectType } from '../../../../../FmhcCheckup/types';

export const separateReportsBySubject = (reports?: GqlFmhcReport[]) => {
  const childGqlReports = (reports ?? []).filter((report) => report.subject.subjectType === SubjectType.Child);
  const familyGqlReports = (reports ?? []).filter((report) => report.subject.subjectType === SubjectType.Family);
  const caregiverGqlReports = (reports ?? []).filter((report) => report.subject.subjectType === SubjectType.Caregiver);
  return { childGqlReports, familyGqlReports, caregiverGqlReports };
};
